// import controller from './query-run-button.controller';
import template from './query-run-button.html';

export default {
	// controller,
	template,
	bindings: {
		loading:  '<?loading',
		disabled: '<?ngDisabled',
	},
	require:  {
		editor: '^^queryEditor',
	},
};
